<template>
  <div>
    <!-- CustomTooltip/question-mark (filter.product.js's `sri` entry has `tips: 'search.tips.SRI'`). -->
    <custom-tooltip :css-class="['pointer']" :section="'search-new-filters-SriRange'" :tooltip-text="$t('search.tips.SRI')"></custom-tooltip>
    <sri-risk-indicators :sri-options="sriOptions" :value="rangeValue" @input="onInput"></sri-risk-indicators>
  </div>
</template>

<script>
import SriRiskIndicators from '../../Search/SriRiskIndicators'
import CustomTooltip from '../../Lib/CustomTooltip'

// SriRange is a RangeInt filter_type, but it is rendered with the dedicated
// SriRiskIndicators chip selector (1-7), not a generic slider.
export default {
  name: 'sriRangeFilter',
  components: { SriRiskIndicators, CustomTooltip },
  props: {
    value: { type: Object, default: null },
  },
  computed: {
    sriOptions() {
      return [1, 2, 3, 4, 5, 6, 7].map((v) => ({ value: v, text: String(v) }))
    },
    rangeValue() {
      return { min: this.value ? this.value.from : null, max: this.value ? this.value.to : null }
    },
  },
  methods: {
    onInput(newValue) {
      this.$emit('input', newValue.min === null && newValue.max === null ? null : { from: newValue.min, to: newValue.max })
    },
  },
}
</script>
